<template type="html">
  <div
    class="nav-menu"
  >
    <div class="logo">
      <router-link :to="{name: 'Dashboard'}">
        <img :src="skinProp('logo')">
      </router-link>
    </div>
    <v-list
      dark
    >
      <template
        v-for="(item, index) in items"
      >
        <hr
          v-if="item.hr"
          :key="index"
        />
        <v-list-item
          v-else
          :key="index"
          :data-index="index"
          :to="item.to"
          :exact="item.exact"
          color="white"
        >
          <v-list-item-icon
            style="width: 35px;margin-right: 15px; justify-content: center;"
          >
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<style lang="scss">
.nav-menu {
  .v-list__tile--active {
    &:hover {
      background-color: #fff !important;
    }
    background-color: #fff;
  }
}
</style>

<style lang="scss" scoped>
.logo {
  text-align: center;
  padding: 7px;
  height: 63px;
  background-color: #fff;
  a {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
hr {
  opacity: 0.4;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['user']),
    items () {
      let items = [
        { title: 'Dashboard', icon: 'fa-tachometer-alt', to: { name: 'Dashboard' }, exact: true },
        { title: 'Instructions', icon: 'fa-info-circle', to: { name: 'Instructions' } },
        { hr: true },
        { title: 'Graphs', icon: 'fa-chart-pie', to: { name: 'Graphs' } },
        { title: 'Data', icon: 'fa-database', to: { name: 'Data' } },
        { title: 'Alerts', icon: 'fa-bell', to: { name: 'Alerts' } },
        { title: 'Reports', icon: 'fa-newspaper', to: { name: 'Reports' } },
        { title: 'Input', icon: 'fa-file', to: { name: 'Input' } },
        { title: 'Users', icon: 'fa-user', to: { name: 'Users' }, admin: true },
        { title: 'Machines', icon: 'fa-cogs', to: { name: 'Machines' }, admin: true },
        { hr: true },
        { title: 'Support', icon: 'fa-life-ring', to: { name: 'Support' } }
      ]

      if (this.user.roles !== 'ROLE_ADMIN') {
        items = items.filter(i => !i.admin)
      }

      return items
    }
  }
}
</script>
